<template>
    <div class="animated fadeIn">
        <LoadingWidget v-if="initStatus != 1" :status="initStatus" @init="init" />
        <b-card v-else>
            <h5 class="mb-0"><i class="fa fa-fw fa-user mr-2" />Divisi Barang</h5>
            <hr />
            <b-row>
                <b-col md="3">
                    <b-form-group label="Nama Divisi">
                        <b-form-input v-model="filter.name" maxlength="50" @keydown.enter="getItems" />
                    </b-form-group>
                </b-col>
                <b-col md="3">
                    <b-form-group label="Aksi">
                        <b-button variant="primary" @click="getItems()">
                            <i class="fa fa-search mr-2" />Cari
                        </b-button>
                    </b-form-group>
                </b-col>
                <b-col md="6" class="text-right">
                    <b-form-group label="Tambah">
                        <b-button variant="success" @click="prepareCreate">
                            <i class="fa fa-plus mr-2" />Divisi Baru
                        </b-button>
                    </b-form-group>
                </b-col>
            </b-row>
            <b-table bordered hover show-empty no-local-sorting
                :busy="isBusy"
                :items="items"
                :fields="fields"
                @sort-changed="onSortChanged"
                responsive class="mb-3"
            >
                <template v-slot:empty>
                    Tidak ada data user.
                </template>
                <template v-slot:cell(name)="row">
                    {{ row.item.name }}
                    <div class="small">{{ row.item.itemKindIds.length }} barang</div>
                </template>
                <template v-slot:cell(desc)="row">
                    {{ row.item.desc }}
                </template>
                <template v-slot:cell(action)="row">
                    <b-button size="sm" variant="warning" v-b-tooltip.hover.top title="Edit" @click="prepareEdit(row.item)">
                        <i class="fa fa-fw fa-pencil" />
                    </b-button>             
                </template>
            </b-table>
            <PageSizer :totalRows="totalRows" :page="currentPage" :options="options" @limit-change="onLimitChange" @page-change="onPageChange" />
        </b-card>
        <b-modal id="m-create" title="Tambah Divisi Baru" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Divisi" description="Nama divisi barang yang ingin dibuat.">
                <b-input v-model="input.name" maxlength="100" />
            </b-form-group>
            <b-form-group v-for="(office, index) in optOffice" :key="'create-office-' + index" :label="'Telepon Admin ' + office.text" description="Nomor telepon admin divisi.">
                <b-input-group prepend="+62">
                    <b-input v-model="input.phones[index].value" maxlength="100" onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Akses yang Diberikan">
                <b-form-checkbox-group
                    v-model="input.itemKinds"
                    :options="optItemKind"
                    stacked
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmCreate">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>
        <b-modal id="m-edit" title="Edit Role" no-close-on-backdrop no-close-on-esc hide-footer>
            <b-form-group label="Nama Divisi" description="Nama divisi barang yang ingin dibuat.">
                <b-input v-model="edit.name" maxlength="100" />
            </b-form-group>
            <b-form-group v-for="(office, index) in optOffice" :key="'edit-office-' + index" :label="'Telepon Admin ' + office.text" description="Nomor telepon admin divisi.">
                <b-input-group prepend="+62">
                    <b-input v-model="edit.phones[index].value" maxlength="100" onkeypress="return event.charCode >= 48 && event.charCode <= 57"/>
                </b-input-group>
            </b-form-group>
            <b-form-group label="Akses yang Diberikan">
                <b-form-checkbox-group
                    v-model="edit.itemKinds"
                    :options="optItemKind"
                    stacked
                />
            </b-form-group>
            <div class="mt-4 text-right">
                <b-button variant="primary" :disabled="isSubmitting" @click="confirmEdit">
                    {{ isSubmitting ? "Menyimpan..." : "Simpan" }}
                </b-button>
            </div>
        </b-modal>  
    </div>
</template>

<script>
export default {
    data() {
        return {

            initStatus: 0,
            isBusy: true,
            isSubmitting: false,

            filter: {
                name: "",
            },

            input: {
                name: "",
                phone: "",
                phones: [],
                itemKinds: []
            },

            edit: {
                id: "",
                name: "",
                phone: "",
                phones: [],
                itemKinds: []
            },

            editItemKind: {
                itemKinds: []
            },

            options: [
                { value: 10, text: '10'},
                { value: 20, text: '20'},
                { value: 30, text: '30'},
                { value: 40, text: '40'},
                { value: 50, text: '50'},
            ],

            fields: [
                { key: "name", label: "Nama Divisi", sortable: true },
                { key: "desc", label: "Jenis Barang", sortable: true },
                { key: "action", label: "Aksi" },
            ],

            items: [],

            currentPage: 1,
            perPage: 10,
            totalRows: 0,
            sortBy: null,
            sortDesc: false,

            optRole: [],

            optItemKind: [],
            optOffice: []

        }
    },

    methods: {

        init() {

            this.initStatus = 0
            let getItems = this.getItems()

            let getRoles = this.$axios.get("role/selection").then(res => {
                this.optRole = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
            })

            let getItemKinds = this.$axios.get("master/kinds").then(res => {
                this.optItemKind = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
            })
            
            let getOffices = this.$axios.get("master/offices").then(res => {
                this.optOffice = res.data.data.map(it => {
                    return { value: it.id, text: it.name }
                })
                this.input.phones = res.data.data.map(it => {
                    return { id: it.id, name: it.name, value: "" }
                })
                this.edit.phones = res.data.data.map(it => {
                    return { id: it.id, name: it.name, value: "" }
                })
            })

            Promise.all([getItems, getRoles, getItemKinds, getOffices]).then(() => {
                this.initStatus = 1
            })
            .catch(_ => {
                this.initStatus = -1
            })

        },

        prepareCreate() {
            this.input.name = ""
            this.input.phone = ""
            this.input.itemKinds = []
            for(let i = 0; i < this.input.phones.length; i++){
                this.input.phones[i].value = ""
            }
            this.$bvModal.show('m-create')
        },

        confirmCreate() {

            if(this.$helper.isBlank(this.input.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.input.itemKinds.length <= 0) {
                return this.$helper.toastError(this, "Mohon memilih jenis barang yang termasuk dalam divisi ini!")
            }

            let isConfirmed = confirm("Simpan divisi barang baru ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.input.name,
                phones: this.input.phones.map(it => {
                    return { id: it.id, phone: it.value }
                }),
                itemKindIds: this.input.itemKinds
            }

            this.isSubmitting = true

            this.$axios.post("division/create", payload).then(_ => {

                this.$helper.toastSuccess(this, "Divisi barang baru berhasil ditambahkan!")
                this.$bvModal.hide("m-create")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        prepareEdit(item) {
            this.edit.id = item.id
            this.edit.name = item.name
            this.edit.phones = item.phones.map(it => {
                return { id: it.id, name: it.name, value: it.admin_phone }
            })
            this.edit.itemKinds = item.itemKindIds
            this.$bvModal.show("m-edit")
        },

        confirmEdit() {

            if(this.$helper.isBlank(this.edit.name)) {
                return this.$helper.toastError(this, "Nama tidak boleh kosong!")
            }

            if(this.edit.itemKinds.length <= 0) {
                return this.$helper.toastError(this, "Mohon memilih jenis barang yang termasuk dalam divisi ini!")
            }

            let isConfirmed = confirm("Simpan perubahan divisi barang ini?")
            if(!isConfirmed) return

            let payload = {
                name: this.edit.name,
                phones: this.edit.phones.map(it => {
                    return { id: it.id, phone: it.value }
                }),
                itemKindIds: this.edit.itemKinds
            }

            this.isSubmitting = true

            this.$axios.post("division/update/" + this.edit.id, payload).then(_ => {

                this.$helper.toastSuccess(this, "Divisi barang berhasil diubah!")
                this.$bvModal.hide("m-edit")
                this.getItems(this.currentPage)

            })
            .catch(error => this.$helper.parseError(this, error))
            .finally(() => this.isSubmitting = false)

        },

        getItems(page = 1) {

            this.isBusy = true
            this.items = []

            if(isNaN(page)) {
                this.currentPage = 1
            }
            else {
                this.currentPage = page
            }

            // URL builder
            let param = this.$helper.getBasePagedQuery(this.currentPage, this.perPage)

            if(!this.$helper.isBlank(this.filter.name)) {
                param += "&name=" + this.filter.name
            }
            
            if(!this.$helper.isBlank(this.sortBy)) {
                param += "&sortBy=" + this.sortBy
                param += "&sortDesc=" + this.sortDesc
            }

            return this.$axios.get("division/get-page" + param).then(res => {
                this.items = res.data.data.items
                this.totalRows = res.data.data.total
                this.items.map(item => {
                    item.desc = ""
                    for(let i = 0; i < item.itemKindNames.length; i++){
                        if(i < item.itemKindNames.length - 1){
                            item.desc += item.itemKindNames[i].name + ", "
                        }
                        else{
                            item.desc += item.itemKindNames[i].name
                        }
                    }
                })
                sessionStorage.setItem("listDivisiFilter", JSON.stringify(this.filter))
            })
            .catch(error => {
                this.$helper.parseError(this, error)
            })
            .finally(() => {
                this.isBusy = false
            })

        },

        onLimitChange(newPerPage) {
            this.perPage = newPerPage
            this.getItems(this.currentPage)
        },

        onPageChange(newPage) {
            this.currentPage = newPage
            this.getItems(this.currentPage)
        },

        onSortChanged(ctx) {
            this.sortBy = ctx.sortBy
            this.sortDesc = ctx.sortDesc
            this.getItems()
        },

    },

    created() {
        if(!this.$helper.isBlank(sessionStorage.getItem("listDivisiFilter"))){
            this.filter = JSON.parse(sessionStorage.getItem("listDivisiFilter"))
        }
        this.init()
    }
}
</script>
